import React from "react";

const Home = () => {
  return (
    <section className="home-section">
      {/* Content */}
      <div className="hero-content">
        <h1>Herzlich Willkommen bei <br /><span className="brand_name">CG Fliesen</span> </h1>
        <p>Ihr Experte für Fliesen, Design und Handwerk.</p>
      </div>
    </section>
  );
};
export default Home;